<script>
export default {
	props: {
		destination: {
			type: String,
			required: false,
		},
		url: {
			type: String,
			required: false,
		},
		title: {
			type: String,
			required: false,
		},
	},
	methods: {
		share() {
			window.open(
				this.link,
				'_blank',
				'width=550,height=600',
			);
		},
	},
	computed: {
		link() {
			return `http://rest.sharethis.com/v1/share/share?destination=${this.destination}&url=${encodeURIComponent(this.url)}&title=${encodeURIComponent(this.title)}`;
		},
	},
};
</script>

<template src="./sky-sharethis.html"></template>
<style src="./sky-sharethis.scss"></style>



// WEBPACK FOOTER //
// sky-sharethis.vue?2f685cdf